export default {
    isBuildingId: state => state.isBuildingId,
    isBuildingName: state => state.isBuildingName,
    isBuildingChange: state => state.isBuildingChange,
    isRegisterNews: state => state.isRegisterNews,
};
